import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import classes from '@nerdwallet/base-styles/classes';
import { Box } from '../Box/Box';
import style from './Cluster.module.less';

var getJustifyContent = function getJustifyContent(align) {
  switch (align) {
    case 'left':
      return 'flex-start';

    case 'center':
      return 'center';

    case 'right':
      return 'flex-end';

    default:
      return undefined;
  }
};

var getAlignItems = function getAlignItems(alignY) {
  switch (alignY) {
    case 'top':
      return 'flex-start';

    case 'center':
      return 'center';

    case 'bottom':
      return 'flex-end';

    default:
      return undefined;
  }
};
/**
 * Simple flexbox container that adds a set amount
 * of horizontal space between each of its children.
 */


export var Cluster = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$alignY = _ref.alignY,
      alignY = _ref$alignY === void 0 ? 'top' : _ref$alignY,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 3 : _ref$spacing,
      className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["align", "alignY", "spacing", "className", "children"]);

  var flattenedChildren = flattenChildren(children);
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    flexWrap: "wrap",
    alignItems: getAlignItems(alignY),
    justifyContent: getJustifyContent(align),
    className: [className, style["offset-".concat(spacing)]],
    ref: ref
  }, otherProps), flattenedChildren.map(function (child, index) {
    // Don't render falsy children.
    if (!child) return null;
    return /*#__PURE__*/React.createElement(Box, {
      marginLeft: spacing,
      marginTop: spacing,
      className: classes('max-width-100') // Default to child.key to enable users to opt in to keyed
      // children. Since the `React.ReactChild` type includes the
      // `string` type, we need to cast the child to `any` to avoid a
      // TypeScript error.
      ,
      key: child.key || index
    }, child);
  }));
});
Cluster.displayName = 'Cluster';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require -- directive added automatically by Shepherd migration
  var PropTypes = require('prop-types');

  Cluster.propTypes = {
    align: PropTypes.oneOf(['left', 'center', 'right']),
    alignY: PropTypes.oneOf(['top', 'center', 'bottom']),
    children: PropTypes.node.isRequired,
    className: PropTypes.string,

    /**
     * The fixed-amount of horizontal space between each child element.
     */
    spacing: PropTypes.oneOf([0, 1, 2, 3, '3-half', 4, 5])
  };
}